export default __webpack_public_path__ + "_/react/assets/sounds/SentMessage.wav";